import React, { useEffect, useState } from 'react';
import { FileText, CheckCircle } from 'lucide-react';

export const PDFGenerationOverlay = ({ status }) => {
    const [progress, setProgress] = useState(0);
    const [stage, setStage] = useState('Démarrage...');

    useEffect(() => {
        let interval;
        if (status === 'generating') {
            setProgress(0);
            setStage('Analyse des données et photos...');

            // Simulate progression
            interval = setInterval(() => {
                setProgress(prev => {
                    const next = prev + (Math.random() * 8 + 2); // Random jump between 2 and 10%

                    if (next > 30 && prev <= 30) setStage('Génération de la mise en page HTML...');
                    if (next > 60 && prev <= 60) setStage('Compilation du PDF par intelligence artificielle...');
                    if (next > 85 && prev <= 85) setStage('Compression et finalisation en cours...');

                    // Cap at 95% until actually finished remotely
                    return next >= 95 ? 95 : next;
                });
            }, 800);
        } else if (status === 'success') {
            setProgress(100);
            setStage('Terminé !');
        }

        return () => clearInterval(interval);
    }, [status]);

    if (status === 'idle') return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(26, 58, 92, 0.95)',
            zIndex: 99999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(8px)',
            color: 'white'
        }}>
            <div style={{
                background: 'rgba(255, 255, 255, 0.05)',
                padding: '40px 60px',
                borderRadius: '24px',
                border: '1px solid rgba(255,255,255,0.1)',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                maxWidth: '500px',
                width: '90%'
            }}>

                <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'rgba(200, 164, 55, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '24px',
                    position: 'relative'
                }}>
                    {progress === 100 ? (
                        <CheckCircle size={40} color="#10B981" />
                    ) : (
                        <FileText size={40} color="#C8A437" style={{ animation: 'pulse 2s infinite' }} />
                    )}

                    {progress < 100 && (
                        <div style={{ position: 'absolute', inset: -5, border: '2px solid rgba(200, 164, 55, 0.3)', borderRadius: '50%', borderTopColor: '#C8A437', animation: 'spin 1s linear infinite' }} />
                    )}
                </div>

                <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '8px', letterSpacing: '-0.5px' }}>
                    {progress === 100 ? 'Document Prêt !' : 'Génération du PDF Officiel'}
                </h2>
                <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '15px', marginBottom: '30px', minHeight: '22px' }}>
                    {stage}
                </p>

                <div style={{ width: '100%', height: '8px', background: 'rgba(255, 255, 255, 0.1)', borderRadius: '4px', overflow: 'hidden', position: 'relative' }}>
                    <div style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: `${progress}%`,
                        background: 'linear-gradient(90deg, #C8A437, #FCD34D)',
                        transition: 'width 0.4s ease-out',
                        borderRadius: '4px'
                    }} />
                </div>

                <div style={{ marginTop: '12px', fontSize: '13px', fontWeight: 'bold', color: '#C8A437', alignSelf: 'flex-end' }}>
                    {Math.round(progress)}%
                </div>

                {progress < 100 && (
                    <p style={{ marginTop: '20px', fontSize: '12px', color: 'rgba(255,255,255,0.4)', fontStyle: 'italic' }}>
                        Veuillez patienter, cette opération peut prendre quelques secondes s'il y a beaucoup de photos...
                    </p>
                )}
            </div>

            <style>{`
                @keyframes pulse {
                    0%, 100% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(0.95); opacity: 0.7; }
                }
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};
